import React from 'react'
import PropTypes from 'prop-types'
import { compose, setPropTypes, pure, onlyUpdateForPropTypes, setDisplayName } from 'recompose'

import './Loading.css'

const propTypes = setPropTypes({
  active: PropTypes.bool.isRequired,
  description: PropTypes.string
})

const enhance = compose(
  setDisplayName('Loading'),
  pure,
  onlyUpdateForPropTypes,
  propTypes
)

const View = ({active, description}) => (
  <div className="Loading" data-active={active}>
    <p className="Loading__text">{description ? description : ''}</p>
    <div className="Loading__spinner"></div>
  </div>
)

export const Loading = enhance(View)



// WEBPACK FOOTER //
// ./src/components/Shared/Loading/Loading.js